import React from 'react';
import { Toast as BootstrapToast } from 'react-bootstrap';
import './Toast.scss';

interface ToastProps {
  show: boolean;
  message: string;
  type?: 'success' | 'error' | 'info' | 'warning';
  onClose: () => void;
  autoClose?: number;
}

const Toast = ({ show, message, type = 'info', onClose, autoClose = 3000 }: ToastProps) => {
  React.useEffect(() => {
    if (show && autoClose) {
      const timer = setTimeout(onClose, autoClose);
      return () => clearTimeout(timer);
    }
  }, [show, autoClose, onClose]);

  return (
    <div className="toast-container">
      <BootstrapToast show={show} onClose={onClose} className={`toast toast-${type}`}>
        <BootstrapToast.Body className="toast-body">
          {message}
        </BootstrapToast.Body>
      </BootstrapToast>
    </div>
  );
};

export default Toast;
